import React, { Component } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  Animated,
  TouchableOpacity,
  PanResponder,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SnackBarDuration, SnackBarInOutDuration, SnackBarPosition } from '../data/Constants';

class SnackView extends Component {
  constructor(props) {
    super(props);

    const { width, height } = Dimensions.get('window');
    this.state = {
      deviceWidth: width,
      deviceHeight: height,
      animatedValue1: new Animated.Value(0),
      animatedValue2: new Animated.Value(1),
    };

    Dimensions.addEventListener('change', this.onWindowChange);

    this._panResponder = PanResponder.create({
      onStartShouldSetPanResponderCapture: () => false,
      onMoveShouldSetPanResponderCapture: () => false,
      onStartShouldSetPanResponder: () => true,
      onMoveShouldSetPanResponder: (evt, gestureState) => {
        const { dx, dy } = gestureState;
        return Math.abs(dx) > 5 || Math.abs(dy) > 5;
      },
      onPanResponderGrant: () => {},
      onPanResponderMove: (evt, gestureState) => this.moveTouch(evt, gestureState),
      onPanResponderTerminationRequest: () => false,
      onShouldBlockNativeResponder: () => false,
    });
  }

  componentDidMount() {
    this.onLifeCycleManage();
  }

  componentWillUnmount() {
    this.onRelease();
  }

  render() {
    const isTop = this.props.position === SnackBarPosition.TOP;

    const translateY = this.state.animatedValue1.interpolate({
      inputRange: [0, 1],
      outputRange: [isTop ? -40 : 40, 0],
    });

    const opacity = this.state.animatedValue1.interpolate({
      inputRange: [0, 0.4, 1],
      outputRange: [0, 0.8, 1],
    });

    const rawBg = (this.props.backgroundColor || '').toLowerCase();
    let bg = '#1F2937';
    let iconName = 'notifications-outline';
    let iconColor = '#6C2BD9';
    let iconBg = '#F0E8FF';

    if (rawBg.includes('green') || rawBg.includes('059669') || rawBg.includes('10b981')) {
      bg = '#ECFDF5';
      iconName = 'checkmark-circle';
      iconColor = '#059669';
      iconBg = '#D1FAE5';
    } else if (rawBg.includes('red') || rawBg.includes('dc2626') || rawBg.includes('pink') || rawBg.includes('ef4444')) {
      bg = '#FEF2F2';
      iconName = 'alert-circle';
      iconColor = '#DC2626';
      iconBg = '#FEE2E2';
    } else if (rawBg.includes('amber') || rawBg.includes('d97706') || rawBg.includes('warning')) {
      bg = '#FFFBEB';
      iconName = 'warning';
      iconColor = '#D97706';
      iconBg = '#FEF3C7';
    } else if (rawBg.includes('6c2bd9') || rawBg.includes('purple')) {
      bg = '#F5F3FF';
      iconName = 'information-circle';
      iconColor = '#6C2BD9';
      iconBg = '#F0E8FF';
    }

    const textColor = bg.startsWith('#F') || bg.startsWith('#E') ? '#111827' : (this.props.textColor || '#FFFFFF');

    return (
      <View
        style={[styles.base, isTop ? { top: 20 } : { bottom: 20 }]}
        pointerEvents="box-none"
      >
        <Animated.View
          style={[
            styles.card,
            {
              backgroundColor: bg,
              borderColor: iconColor + '40',
              transform: [{ translateY }],
              opacity,
            },
          ]}
          {...this._panResponder.panHandlers}
        >
          <View style={[styles.iconWrap, { backgroundColor: iconBg }]}>
            <Ionicons name={iconName} size={18} color={iconColor} />
          </View>

          <Text style={[styles.messageText, { color: textColor }]} numberOfLines={this.props.numberOfLines || 3}>
            {this.props.data}
          </Text>

          <TouchableOpacity
            style={styles.closeBtn}
            onPress={() => this.onHideAnimated(false)}
            activeOpacity={0.7}
          >
            <Ionicons name="close" size={14} color="#6B7280" />
          </TouchableOpacity>
        </Animated.View>
      </View>
    );
  }

  moveTouch = (evt, gestureState) => {
    if (this.props.isAllowSlideExit) {
      if (this.props.position === SnackBarPosition.TOP && gestureState.vy < -0.2) {
        this.onHideAnimated(true);
      } else if (this.props.position === SnackBarPosition.BOTTOM && gestureState.vy > 0.2) {
        this.onHideAnimated(true);
      }
    }
  };

  onLifeCycleManage = () => {
    this.inAnimated = Animated.timing(this.state.animatedValue1, {
      toValue: 1,
      duration: SnackBarInOutDuration,
      easing: this.props.inEasing,
      useNativeDriver: false,
    });

    this.inAnimated.start(() => {
      if (this.props.duration !== SnackBarDuration.INDEFINITE) {
        this.commonAnimated = Animated.sequence([
          Animated.timing(this.state.animatedValue2, {
            toValue: 1,
            duration: this.props.duration,
            useNativeDriver: false,
          }),
          Animated.timing(this.state.animatedValue1, {
            toValue: 0,
            duration: SnackBarInOutDuration,
            useNativeDriver: false,
          }),
        ]);
        this.commonAnimated.start();
      }
    });
  };

  onHideAnimated = (isSlideHide) => {
    if (!this.isHasHide) {
      this.isHasHide = true;
    } else {
      return;
    }
    if (this.props.onActionHide) this.props.onActionHide(isSlideHide);
    this.hideAnimated = Animated.timing(this.state.animatedValue1, {
      toValue: 0,
      duration: SnackBarInOutDuration,
      useNativeDriver: false,
    });
    this.hideAnimated.start(() => {
      this.onRelease();
    });
  };

  onWindowChange = ({ window }) => {
    const { width, height } = window;
    if (width !== this.state.deviceWidth && height !== this.state.deviceHeight) {
      this.setState({
        deviceWidth: width,
        deviceHeight: height,
      });
    }
  };

  onRelease = () => {
    if (this.inAnimated) {
      this.inAnimated.stop();
      this.inAnimated = undefined;
    }
    if (this.commonAnimated) {
      this.commonAnimated.stop();
      this.commonAnimated = undefined;
    }
    if (this.hideAnimated) {
      this.hideAnimated.stop();
      this.hideAnimated = undefined;
    }
    Dimensions.removeEventListener('change', this.onWindowChange);
  };
}

const styles = StyleSheet.create({
  base: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999999,
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 320,
    maxWidth: 540,
    width: '90%',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 12,
    borderWidth: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 8,
  },
  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    flexShrink: 0,
  },
  messageText: {
    flex: 1,
    fontSize: 13.5,
    fontWeight: '600',
    lineHeight: 20,
  },
  closeBtn: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 12,
    flexShrink: 0,
  },
});

export default SnackView;
